const updates = [
  {
    date: '07-30',
    title: '某知名导演新片拍摄现场路透流出，豪华阵容引期待',
    tag: '影视动态',
    hot: true,
  },
  {
    date: '07-30',
    title: '音乐节后台冲突视频曝光，多位艺人被卷入争议',
    tag: '热点事件',
    hot: true,
  },
  {
    date: '07-29',
    title: '热门综艺选手赛前猛料被扒，节目组回应引争议',
    tag: '综艺爆料',
    hot: false,
  },
  {
    date: '07-29',
    title: '某品牌代言人突遭解约，知情人透露背后另有隐情',
    tag: '商业八卦',
    hot: true,
  },
  {
    date: '07-28',
    title: '短视频平台头部网红集体停更，粉丝猜测纷纷',
    tag: '网红风云',
    hot: false,
  },
  {
    date: '07-28',
    title: '颁奖礼后台明星互动细节曝光，细节耐人寻味',
    tag: '明星动态',
    hot: false,
  },
  {
    date: '07-27',
    title: '知名制片人被曝资金链断裂，多个项目恐受影响',
    tag: '行业爆料',
    hot: false,
  },
  {
    date: '07-27',
    title: '某女星社交平台小号被扒，内容信息量巨大',
    tag: '深度吃瓜',
    hot: true,
  },
  {
    date: '07-26',
    title: '热门IP改编剧选角内幕曝光，原著粉集体破防',
    tag: '影视八卦',
    hot: false,
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1024px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            最新快讯
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            51吃瓜视频实时追踪最新娱乐圈动态与热点事件
          </p>
        </div>
        <div className="relative">
          {/* Timeline line */}
          <div className="absolute left-[19px] top-3 bottom-3 w-px bg-background-300 hidden md:block" />
          <div className="space-y-3">
            {updates.map((item, i) => (
              <div key={i} className="flex gap-4 items-start">
                <div className="hidden md:flex w-10 flex-shrink-0 flex-col items-center relative z-10">
                  <div className={`w-2.5 h-2.5 rounded-full border-2 ${
                    item.hot
                      ? 'bg-accent-500 border-accent-500'
                      : 'bg-background-50 border-background-300'
                  }`} />
                </div>
                <div className="flex-1 bg-background-50 rounded-xl border border-background-200/70 p-4 hover:border-primary-200/60 transition-colors cursor-pointer">
                  <div className="flex items-center gap-2 md:gap-3 flex-wrap">
                    <span className="text-xs text-foreground-400 font-mono flex-shrink-0">
                      {item.date}
                    </span>
                    <span className={`px-2 py-0.5 rounded-md text-xs font-medium flex-shrink-0 ${
                      item.hot
                        ? 'bg-accent-100 text-accent-700'
                        : 'bg-secondary-100 text-secondary-700'
                    }`}>
                      {item.tag}
                    </span>
                    {item.hot && (
                      <span className="text-xs text-accent-500 font-medium flex items-center gap-1 flex-shrink-0">
                        <i className="ri-fire-line"></i>
                        HOT
                      </span>
                    )}
                    <h3 className="text-sm text-foreground-800 font-medium leading-snug">
                      {item.title}
                    </h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}